import React, { memo, useContext, useEffect, useRef, useState } from "react";
import { Box, useTheme } from "@mui/material";
import Back from "features/metadesk/components/Back";
import {
  StyledWhiteCardContainer,
  StyledAddContract,
} from "./AddContract.styles";
import _ from "lodash";
import ContractField from "./ContractField";
import { useForm, FormProvider, useFieldArray } from "react-hook-form";
import FixedButton from "features/metadesk/settings/common/FixedButton";
import { Button, VARIANT } from "@metacrm/metacrm-material-ui/dist/Button";
import { v4 as uuidv4 } from "uuid";
import { useDispatch } from "react-redux";
import { alertInfo, alertServerError } from "features/helpers/utils";
import axios from "axios";
import { apiUrl } from "features/configure";
import { useNavigate, useOutletContext } from "react-router";
import useNavigateEntity from "hooks/useNavigateEntity";
import { Loading } from "features/common";
import { useIntl } from "react-intl";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import { get, isEmpty } from "lodash-es";
import { parseCustomDomainUrl } from "features/helpers/utils";

const defaultValues = {
  contracts: [
    {
      name: "",
      ecosystem: "",
      chainId: "",
      smartContractAddress: "",
      _id: uuidv4(),
    },
  ],
};

function AddContract() {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const [errorBarShow, setErrorBarShow] = useState(false);
  const [entityName, isCustomDomain] = useOutletContext();

  const dispatchSnackbar = useDispatchSnackbar();

  const methods = useForm({
    mode: "onSubmit",
  });
  const {
    handleSubmit,
    getValues,
    formState: { errors: errorsInfo, isValid },
  } = methods;

  const [formData, setFormData] = useState(defaultValues);
  const [loading, setLoading] = useState(false);
  const { navigateEntity } = useNavigateEntity();
  const objectiveRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // 有建立過合約 就導去列表頁面
  async function getObjectiveList() {
    try {
      setLoading(true);
      const { data } = await axios.get(
        apiUrl + `/api/dAppTracking/${entityName}/contracts`
      );
      if (get(data, "contracts", []).length > 0) {
        navigate(
          parseCustomDomainUrl(
            isCustomDomain,
            entityName,
            `/analytics/settings/dapp-activity-tracking`
          )
        );
      }
    } catch (err) {
      dispatchSnackbar({ err });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getObjectiveList();
  }, []);

  const handleAddContract = () => {
    setFormData((prev) => ({
      ...prev,
      contracts: [
        ...prev.contracts,
        {
          name: "",
          ecosystem: "",
          chainId: "",
          smartContractAddress: "",
          _id: uuidv4(),
        },
      ],
    }));
  };

  const handleDeleteContract = (id) => {
    setFormData((prev) => ({
      ...prev,
      contracts: prev.contracts.filter((item) => item._id !== id),
    }));
  };

  const handleCreate = async () => {
    // const isFormValid = await methods.trigger();
    console.log("formData: ", formData);

    try {
      setErrorBarShow(false);

      if (isValid) {
        await axios.post(apiUrl + `/api/dAppTracking/${entityName}/contracts`, {
          contracts: _.map(formData?.contracts, (contract) => ({
            ecosystem: contract.ecosystem,
            chainId: contract.chainId,
            name: contract.name,
            contractAddress: contract.smartContractAddress,
          })),
        });
        dispatch(alertInfo("Create Objective Success"));
        navigateEntity("/analytics/settings/dapp-activity-tracking");
      } else {
        setErrorBarShow(true);
      }
    } catch (err) {
      dispatch(alertServerError(err));
    }
  };

  return (
    <Box position={"relative"}>
      <Loading open={loading} fullScreen={true} />
      <FormProvider {...methods}>
        <div className="fade-up">
          <Back />
          <Box className="title">
            {formatMessage({ id: "global.btn.addContract" })}
          </Box>
          <Box
            sx={{
              fontSize: "14px",
              color: theme.customColors.grey[600],
              marginTop: "8px",
              marginBottom: "24px",
            }}
          >
            {formatMessage({
              id: "dAppTracking.settings.description",
            })}
          </Box>
        </div>
        <div className="fade-up-more">
          {errorBarShow && (
            <Box
              sx={{
                background: "#FFEEEE",
                borderRadius: "4px",
                padding: "16px 32px",
                color: theme.customColors.pink[600],
                marginBottom: "12px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box
                component="i"
                marginRight="8px"
                className="meta-crm-icon-ic_x_circle_contained font-size-16"
              />
              {formatMessage({ id: "global.inputCheck.incompleteFields" })}
            </Box>
          )}

          {formData?.contracts?.map((contract, index) => (
            <ContractField
              contractData={contract}
              ref={objectiveRef}
              contractIndex={index}
              formData={formData}
              isTargetEvent={true}
              setFormData={setFormData}
              onDelete={handleDeleteContract}
            ></ContractField>
          ))}

          <StyledAddContract onClick={handleAddContract}>
            <Box
              component="i"
              className="meta-crm-icon-ic_add font-size-16"
              mr="8px"
            />
            {formatMessage({ id: "global.btn.addContract" })}
          </StyledAddContract>
        </div>
        <FixedButton>
          <Button
            variant={VARIANT.TEXT}
            style={{ width: 144 }}
            onClick={() =>
              navigateEntity("/analytics/settings/dapp-activity-tracking")
            }
          >
            {formatMessage({ id: "global.btn.discard" })}
          </Button>
          <Button
            onClick={() => handleSubmit(handleCreate)}
            style={{ width: 144 }}
            // disabled={!isValid}
          >
            {formatMessage({ id: "global.btn.save" })}
          </Button>
        </FixedButton>
      </FormProvider>
    </Box>
  );
}

export default memo(AddContract);
